// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./globalVariables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-full {
  width: 100%;
}
.header-right-content {
  display: inline-block;
  float: right;
  margin-right: 15px;
}
.p-0 {
  padding: 0px !important;
}
.shadow-picker.ant-picker {
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  border: none;
  height: 40px;
}
.shadow-input {
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  border: none;
  height: 40px;
}
.shadow-select .ant-select-selector {
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  border: none !important;
  height: 40px !important;
}
.shadow-select .ant-select-selection-placeholder {
  line-height: 40px !important;
}
.shadow-select .ant-select-selector .ant-select-selection-item {
  line-height: 40px;
}
.p-6 {
  padding: 1.4rem;
}
.max-width-100 {
  max-width: 100%;
}
.full-width {
  width: 100%;
}
.is-active {
  background: var(--sd_primary);
}
.table-search-bar .form-control {
  color: #222;
  background-color: #f0f2f5;
  border: 1px solid #f0f2f5;
}
.table td,
.table th {
  border-top: 1px solid #f0f2f5;
  vertical-align: middle;
}
.table td p {
  margin-bottom: 0px !important;
}
.ant-dropdown-button button {
  background: #f0f2f5;
  border: none;
}
.ant-dropdown-button button:hover,
.ant-dropdown-button button:focus,
.ant-dropdown-button button:active {
  background: #f0f2f5;
  border: none;
  color: #45bd5b;
}
.total-spinner {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.total-spinner-backdrop {
  z-index: 99;
  width: 100%;
  height: 100%;
  position: absolute;
  background: #ffffff99;
}
.ant-spin-dot-item {
  background: #45bd5b;
}
.react-bootstrap-table .anticon-eye svg {
  color: var(--sd_primary);
  font-size: 16px;
  cursor: pointer;
}
.dashboard-layout .logo img {
  height: 32px;
  margin: 16px;
}
.ant-layout-sider-collapsed .logo img {
  margin: 15px 24px;
}
.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0px 24px;
  text-align: center;
}
.ant-menu-inline-collapsed .sidebar-icon {
  margin-right: 0px;
}
.ant-layout-sider {
  flex: 0 0 230px !important;
  max-width: 230px !important;
  min-width: 230px !important;
  width: 230px !important;
}
.ant-layout-sider-collapsed {
  flex: 0 0 80px !important;
  max-width: 80px !important;
  min-width: 80px !important;
  width: 80px !important;
}

.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type),
.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type),
.ant-tabs-card.ant-tabs-top
  > div
  > .ant-tabs-nav
  .ant-tabs-tab:not(:last-of-type),
.ant-tabs-card.ant-tabs-bottom
  > div
  > .ant-tabs-nav
  .ant-tabs-tab:not(:last-of-type) {
  margin-right: 8px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.add-content-button {
  z-index: 9;
  margin-bottom: 10px;
  float: right;
}
.view-name {
  cursor: pointer;
}
.view-name:hover {
  color: #45bd5b;
}
.ant-pagination-item-active {
  border-color: var(--sd_primary);
}
.ant-pagination-item-active a {
  color: var(--sd_primary);
}
.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  border-color: var(--sd_secondary);
}
.ant-pagination-item-active:focus a,
.ant-pagination-item-active:hover a {
  color: var(--sd_secondary);
}
.ant-input,
.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-picker,
.ant-btn,
.ant-card,
.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab,
.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab,
.ant-alert {
  border-radius: 7px;
}

/* tab styles */
.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,
.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {
  background: #0fa0cf;
}
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.ant-tabs-tab:hover {
  color: #0fa0cf;
}

/* practitioner details card tab styles */
.tab-style > .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
  background: var(--sd_secondary);
}
.item-details-modal .ant-tabs-tab:hover {
  color: var(--sd_secondary);
}
.ant-list-split .ant-list-item {
  border: none;
}
.data-table {
  position: relative;
}
.data-table thead {
  background: var(--sd_primary_low);
  color: var(--sd_primary_dark);
}
.data-table .table thead th {
  outline-color: var(--sd_primary);
}
.react-bootstrap-table-pagination .page-item.active .page-link {
  background: var(--sd_primary_dark);
  border-color: var(--sd_primary_dark);
  outline: none;
}
.react-bootstrap-table-pagination .page-link:focus {
  outline: none;
  box-shadow: none;
}
.react-bootstrap-table-pagination .page-link {
  color: var(--sd_primary);
}
.react-bootstrap-table-pagination .active .page-link:hover {
  color: var(--white);
}
.react-bootstrap-table-pagination .page-link:hover {
  color: var(--sd_primary_dark);
}
.react-bootstrap-table-pagination .btn-secondary {
  background-color: var(--sd_primary);
  border-color: var(--sd_primary);
}
.react-bootstrap-table-pagination .btn-secondary.focus,
.btn-secondary:focus {
  box-shadow: none;
}
.react-bootstrap-table-pagination
  .btn-secondary:not(:disabled):not(.disabled).active,
.react-bootstrap-table-pagination
  .btn-secondary:not(:disabled):not(.disabled):active,
.react-bootstrap-table-pagination .show > .btn-secondary.dropdown-toggle {
  background: var(--sd_primary_dark);
  border-color: var(--sd_primary_dark);
  outline: none;
  box-shadow: none;
}
.react-bootstrap-table-pagination .dropdown-menu a {
  color: var(--sd_primary);
}
.ant-btn:hover,
.ant-btn:focus {
  color: var(--sd_primary);
  border-color: var(--sd_primary);
}
.data-table .table thead th {
  border-bottom: none;
}
.data-table .table th {
  border-top: none;
}
.search-label {
  float: right;
}
.capitalize {
  text-transform: capitalize;
}
.react-bootstrap-table-pagination-total {
  margin-left: 15px;
}
.sidebar-icon {
  width: 1.2rem;
  margin-right: 10px;
}
.ant-menu-inline-collapsed {
  width: 100%;
}
.ant-menu-inline-collapsed .ant-menu-submenu-title span {
  display: inline-block;
  max-width: 0;
  opacity: 0;
}
.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: var(--sd_primary_dark);
}
.ant-table-thead th.ant-table-column-has-sorters:hover {
  background: var(--sd_primary_low);
}
.ant-btn-primary {
  background: #45bd5b;
  border: none;
}
.ant-btn-secondary {
  background: #0fa0cf;
  border: none;
  color: var(--white);
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: linear-gradient(60deg, #66bb6a, #43a047);
}
.ant-btn-primary:hover,
.ant-btn-primary:focus,
.ant-btn-primary:active,
.ant-btn-primary:focus-within,
.ant-btn-primary:visited {
  background: #24ad3e;
  border: none;
  color: var(--white);
}
.ant-btn-secondary:hover,
.ant-btn-secondary:focus,
.ant-btn-secondary:active,
.ant-btn-secondary:focus-within,
.ant-btn-secondary:visited {
  background: #0e93c0;
  border: none;
  color: var(--white);
}
.dashboard-layout .trigger {
  padding: 0 24px;
  font-size: 18px;
  line-height: 64px;
  cursor: pointer;
  transition: color 0.3s;
  color: var(--sd_primary);
}

.dashboard-layout .trigger:hover {
  color: var(--sd_secondary);
}
.dashboard-layout
  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
  .ant-menu-item-selected {
  background: linear-gradient(60deg, #66bb6a, #43a047);
}
.alpha-dummy-avatar {
  text-transform: uppercase;
  text-align: center;
  height: 70px;
  width: 70px;
  line-height: 70px;
  font-size: 34px;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  color: var(--white);
  background: var(--sd_primary);
}
.ant-menu-sub .ant-menu-item {
  padding-left: 30px !important;
}

.dashboard-layout .site-layout .site-layout-background {
  background: var(--white);
}
.dashboard-layout .ant-layout-content {
  min-height: 84vh !important;
}
.dashboard-layout .site-layout-background.content {
  margin: 24px 16px;
  padding: 12px 24px;
  min-height: 280px;
}
.table-avatar {
  border-radius: 5px;
  border: 1px solid;
  border-color: var(--light_grey);
  height: 40px;
  width: 40px;
  overflow: hidden;
  margin-right: 10px;
  display: inline-block;
}
ul.languages-spoken-names {
  list-style: none;
  display: inline-flex;
  margin-bottom: 0px;
  padding-left: 0px;
}
ul.languages-spoken-names li:not(:last-child):after {
  content: ", ";
}

.doctor-speciality {
  padding: 3px 12px;
  color: #45bd5b;
  text-transform: uppercase;
  background: #ffffff;
  border-radius: 3px;
  font-weight: 600;
  box-shadow: 1px 2px 7px #00000045;
  font-size: 12px;
}
.table-avatar img {
  max-width: 100%;
  height: auto;
}
.table-avatar-name span {
  display: inline-block;
}
.ant-switch {
  background-color: var(--light_red);
}
.item-details-modal .ant-modal-header {
  display: none;
}
.item-details-modal .ant-modal-content {
  border-radius: 10px;
}
.item-details-modal .ant-tabs-nav {
  margin-bottom: 5px;
}
.item-details-modal .ant-tabs-content-holder {
  padding: 0px;
}
.item-details-modal .ant-tabs-content-holder .general-info .column-items {
  margin: 0px 0px 5px 0px;
}
.item-details-modal .ant-tabs-content-holder .general-info .column-item {
  margin: 0px;
  padding: 5px;
}
.general-info .column-item-inner {
  background: #f5f8f9;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.item-details-modal .contact-info {
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  display: flex;
}
.item-details-modal .contact-info svg {
  color: #45bd5b;
}
.item-details-modal .health-info-row {
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  display: flex;
}
.item-details-modal .blood-group,
.item-details-modal .weight,
.item-details-modal .height {
  flex-grow: 1;
  margin-bottom: 10px;
  padding: 0px 5px;
}
.item-details-modal .contact-info .email,
.item-details-modal .contact-info .mobile,
.item-details-modal .contact-info .address,
.item-details-modal .contact-info .telephone,
.item-details-modal .contact-info .user,
.item-details-modal .contact-info .auto-approval,
.item-details-modal .contact-info .languages-spoken {
  flex-grow: 1;
  margin-bottom: 10px;
  padding: 0px 5px;
  width: 50%;
}

.item-details-modal .contact-info svg {
  margin-right: 5px;
}
.item-details-modal .department-info,
.item-details-modal .service-info {
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  display: flex;
}
.item-details-modal .department-info span,
.item-details-modal .service-info span {
  vertical-align: middle;
  flex-grow: 1;
}
.item-details-modal .department-info span.item,
.item-details-modal .service-info span.item {
  font-size: 14px;
  flex-grow: inherit;
  border: 1px solid #45bd5b38;
  border-radius: 5px;
  margin: 3px;
  padding: 2px 10px;
  background: #45bd5b0d;
}
.item-details-modal .department-info span.item svg,
.item-details-modal .service-info span.item svg {
  color: #45bd5b;
  margin-right: 5px;
}
.item-details-modal .cover-image-holder {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  height: 100px;
  background-position: 50% 45%;
  background-size: cover;
  background-repeat: no-repeat;
}

.item-details-modal .profile-image {
  border-radius: 10px;
  height: 90px;
  display: inline-block;
  box-shadow: 0 0 15px #00000014;
  width: 90px;
  border: 3px solid #fff;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: -45px;
}
.data-table > .react-bootstrap-table {
  margin-top: 0px;
}
.item-details-modal .profile-info {
  vertical-align: text-bottom;
  display: inline-block;
  padding: 0px 10px;
}
.profile-info h4 {
  margin-bottom: 0px;
}
.profile-info svg {
  color: #45bd5b;
  margin-right: 3px;
}
.item-details-modal .basic-information {
  margin-top: -35px;
  padding: 20px;
}
.item-details-modal .basic-information.doctor {
  margin-top: -35px;
}
.item-details-modal .ant-modal-body {
  padding: 0px;
}
.item-details-modal .ant-modal-close-x {
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.working-hours .day {
  display: flex;
  padding: 5px;
}
.working-hours .day .label {
  min-width: 100px;
  font-weight: 600;
}
.ant-switch-checked {
  background: #45bd5b;
}
.order-item {
  cursor: pointer;
}
.react-bootstrap-table {
  max-width: 100%;
  overflow: scroll;
  margin-top: 25px;
}
.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {
  margin-top: 13px;
  margin-right: 7px;
}
.ant-steps-item-process
  .ant-steps-item-icon
  > .ant-steps-icon
  .ant-steps-icon-dot,
.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
.ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-tail::after,
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {
  background: #45bd5b;
}
.ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  font-size: 14px !important;
  line-height: 30px !important;
}
.ant-steps-item-wait
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title,
.ant-steps-item-wait
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-description {
  color: #222 !important;
}
.ant-steps-item-description {
  font-size: 12px;
  color: #222 !important;
}
.data-table h5 {
  display: inline;
  margin-bottom: 0px;
}
.table-search-bar {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

@media only screen and (max-width: 600px) {
  .table-search-bar {
    justify-content: center;
  }
}

.table-search-bar input {
  width: 300px;
}
.go-back-icon {
  margin-right: 10px;
}
.go-back-icon svg {
  height: 20px;
  width: 20px;
  vertical-align: text-bottom;
  color: #45bd5b;
}
.ant-drawer-header,
.ant-modal-header {
  padding: 10px 24px;
  background: #45bd5b1a;
}
.ant-drawer-close {
  padding: 12px;
}
.ant-drawer-title,
.ant-modal-title {
  color: #45bd5b;
}
.ant-modal-close-x {
  width: 42px;
  height: 42px;
  line-height: 42px;
}
.ant-modal-footer button:first-child {
  border: none;
  background: #f0f2f5;
}
.ant-drawer-body input[type="text"] {
  height: 40px;
  line-height: 40px;
}
.ant-drawer-body
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  height: 40px;
}
.ant-drawer-body
  .ant-select-single
  .ant-select-selector
  .ant-select-selection-item {
  line-height: 40px;
}
.fileUploader {
  width: 50%;
}
.fileContainer {
  box-shadow: none !important;
  padding: 0px;
}
.fileContainer .chooseFileButton {
  background: #eff2f5 !important;
  color: #222 !important;
}
.procedure-image-uploader {
  display: flex;
  padding: 15px 0px;
}
.procedure-preview-image {
  height: 120px;
  padding: 15px;
  width: auto;
}
.ql-toolbar.ql-snow,
.ql-container.ql-snow {
  border: 1px solid #eff2f5;
}
.procedure-gallery-uploader {
}
.procedure-gallery-uploader p {
  padding: 20px 10px;
  text-align: center;
  border-radius: 5px;
  background: #eff2f5;
  border: 1px dotted #ddd;
  margin-bottom: 0px;
}
.app_status {
  font-size: 12px;
  border-radius: 3px;
  border: 1px solid;
  padding: 3px 9px;
}
.app_status.notresponded {
  border-color: #e29200;
  background: #ffa50036;
  color: #e29200;
}
.app_status.notattended {
  border-color: #929292;
  background: #9292922b;
  color: #929292;
}
.app_status.completed {
  border-color: #0fa0cf;
  background: #0fa0cf1f;
  color: #0fa0cf;
}
.app_status.checkedin {
  border-color: #096dd9;
  background: #096dd926;
  color: #096dd9;
}
.app_status.pending {
  border-color: #ff6c04;
  background: #ff6c0426;
  color: #ff6c04;
}
.app_status.cancelled {
  border-color: #dc3545;
  background: #dc354529;
  color: #dc3545;
}
.app_status.approved {
  border-color: #28a745;
  background: #28a7452e;
  color: #28a745;
}
.app_status.rescheduled {
  border-color: #28a7a1;
  background: #28a7a121;
  color: #28a7a1;
}
.app_status.checkedout {
  border-color: #0e7526;
  background: #0e75262e;
  color: #0e7526;
}
.app_status.videoconference {
  border-color: #9703a9;
  background: #9703a92b;
  color: #9703a9;
}
.anticon {
  vertical-align: middle;
}
button.add-procedure {
  margin-top: 15px;
  width: 100%;
  padding: 10px;
  height: 40px;
  color: #fff;
  line-height: 10px;
  background: #45bd5b;
}
button.add-procedure:hover {
  color: #fff;
  background: #45bd5b;
}
.appointments-container {
  display: flex;
  flex-direction: column;
}

.row-align-right {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.patient-details-container,
.procedure-container,
.quickbooking-container {
  background-color: white;
  padding: 18px;
  border-radius: 6px;
}
.appointments-history-container {
  background-color: white;
  padding: 18px;
  border-radius: 6px;
  margin-top: 1rem;
}
.appointment-details-container {
  background-color: white;
  padding: 15px;
}
.item-details-modal .general-info {
  display: flex;
  flex-direction: column;
}
.item-details-modal .general-info .item {
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 5px;
}
.item h4 {
  margin: 0;
}
.item .label-gray {
  color: gray;
  font-size: 15px;
  margin-bottom: 0px;
}
.item .text-black {
  color: black;
  font-size: 18px;
  margin-top: 0px;
}
.appointment-id {
  padding: 3px 12px;
  color: #45bd5b;
  text-transform: uppercase;
  background: #ffffff;
  border-radius: 3px;
  font-weight: 600;
  box-shadow: 1px 2px 3px #00000045;
  font-size: 16px;
  margin-top: 3px;
}
.appointment-token{
  padding: 3px 10px;
  color: #45bd5b;
  text-transform: uppercase;
  background: #ffffff;
  border-radius: 3px;
  font-weight: 400;
  font-size: 12px;
  margin: 3px;
  border: 1px solid rgba(220, 220, 220, 0.7);
}
.dob-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.dob-wrapper .label {
  font-size: 13px;
  color: gray;
}
.dob-wrapper .dob {
  font-size: 14px;
  color: black;
  margin-left: 5px;
  font-weight: 500;
}
.details-wraper {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 5px;
  padding: 3px 15px;
  border-radius: 5px;
  width: 100%;
  background: #f5f8f9;
}
.details-wraper h4,
label {
  margin: 0;
}
.details-wraper .icon {
  height: 18px;
  width: auto;
}
.details-wraper label {
  font-size: 16px;
  color: gray;
  min-width: 32%;
  font-weight: normal;
}
.details-wraper .text {
  font-size: 16px;
  color: rgb(19, 19, 19);
  margin-left: 8px;
  font-weight: 400;
}
.prescription-container,
.report-container {
  padding: 1rem;
}
.prescription-container h1 {
  font-size: 15px;
  color: rgb(63, 63, 63);
}
.order-details-container .general-info {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-top: 0px;
}
.payments-container,
.appointments-container {
  /* background-color: white; */
  border-radius: 7px;
}
.reschedule-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.reschedule-container .header-section {
  width: 100%;
  height: 3rem;
  background-color: white;
  display: flex;
  flex-direction: row;
  padding: 1rem;
  position: relative;
}
.reschedule-container .date-header {
  font-size: 14px;
  font-weight: 500;
  color: black;
  margin-right: 3px;
}
.reschedule-container .today-header {
  font-size: 14px;
  font-weight: 500;
  color: #7dbe7a;
  margin-left: 6px;
  cursor: pointer;
}
.reschedule-container .disabled {
  color: rgb(139, 139, 139);
  font-weight: 400;
}
.reschedule-container .right-section {
  align-self: center;
  position: absolute;
  right: 2rem;
}
.reschedule-container .dates-container {
  width: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fcfcfc;
  overflow: scroll hidden;
  margin-bottom: 10px;
}
.dates-container .date-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid gray;
  border-radius: 3px;
  padding: 10px 5px;
  cursor: pointer;
  color: gray;
  margin-left: 10px;
  height: 60px;
}
.dates-container .selected {
  background-color: #7dbe7a;
  border: none;
}
.date-card .day {
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  margin-bottom: 0.5rem;
}
.date-card .selected {
  color: white;
  font-weight: 600;
}
.date-card .month {
  font-size: 8px;
  font-weight: 400;
  margin: 0;
  text-align: center;
  width: 40px;
}
.reschedule-container .times-container {
  width: 100%;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  grid-gap: 0.5rem;
  gap: 0.5rem;
}
.times-container .time-card {
  display: grid;
  place-items: center;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 0.25rem;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  background-color: rgba(239, 243, 247);
  font-weight: 600;
  color: rgba(75, 89, 102);
  pointer-events: auto;
}

.times-container .disabled {
  background-color: rgb(245, 245, 245);
  font-weight: 500;
  color: rgb(146, 146, 146);
}
.times-container .selected {
  color: rgba(116, 190, 118);
  border: 1px solid rgba(116, 190, 118);
  font-weight: 700;
  background-color: white;
}
.times-container .leave {
  color: #ff0000;
  border: 1px solid rgb(252, 65, 65);
  font-weight: 700;
  background-color: white;
}
.reschedule-container .btn-footer {
  width: 100%;
  padding: 0.5rem 0.5rem;
  display: grid;
  place-items: center;
  font-size: 18px;
  font-weight: 500;
  color: white;
  background-color: #7dbe7a;
  border-radius: 0px 0px 5px 5px;
  cursor: pointer;
}
.reschedule-container .btn-footer:hover{
  font-style: italic;
  box-shadow: 2px -2px 5px 1px #575457;
}
/* .image-cropper-modal .ant-modal-footer{
  display: none;
} */
.reschedule-container .btn-footer:active { 
  transform: scale(0.8);  
} 
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background-color: white;
}
@media (max-width: 992px) {
  .dashboard-layout .site-layout-background.content {
    overflow: scroll;
  }
}
@media (max-width: 767px) {
  .add-content-button {
    float: left;
  }
  .react-bootstrap-table-pagination .btn-secondary {
    margin-bottom: 10px;
  }
}
.action_status.requested {
  border-color: #e29200;
  background: #ffa50036;
  color: #e29200;
}
.action_status.accept {
  border-color: #28a745;
  background: #28a7452e;
  color: #28a745;
}
.action_status.reject {
  border-color: #dc3545;
  background: #dc354529;
  color: #dc3545;
}
.action_status.send_request {
  border-color: #096dd9;
  background: #096dd926;
  color: #096dd9;
}

.ant-input-affix-wrapper {
  border-radius: 7px;
}

.table > thead > tr > th:first-child {
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}
.table > thead > tr > th:last-child {
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
.ant-input-group.ant-input-group-compact > *:first-child,
.ant-input-group.ant-input-group-compact
  > .ant-select:first-child
  > .ant-select-selector,
.ant-input-group.ant-input-group-compact
  > .ant-select-auto-complete:first-child
  .ant-input,
.ant-input-group.ant-input-group-compact
  > .ant-cascader-picker:first-child
  .ant-input {
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  /* border-radius: 10px; */
}
@media (min-width: 991px) {
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    position: absolute;
  }
}

/* notification css*/

.notification_container {
  padding: 10px;
  height: 100%;
  background: #fafafc;
}

.notification_container > .title_day {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #8e95a5;
}

.title_container {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.notification {
  cursor: pointer;
  margin-top: 8px;
  padding: 6px;
  background: #fff;
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 7px;
}
.notification_bottom {
  cursor: pointer;
  text-align: center;
  margin-top: 15px;
  background: #45bd5b;
  color: white;
  font-weight: 600;
  padding: 10px;
  border-radius: 5px;
}

.divider {
  padding-top: 6px;
  border-bottom: 2px solid #f8f8f8;
  margin-left: 2%;
}

.notification > .title_container > .title {
  font-weight: normal;
  font-size: 14px;
  width: 300px;
  line-height: 1.3;
}

.notification > .title_container > .time {
  font-weight: 600;
  color: #acacac;
  font-size: 12px;
}

.notification > .circle {
  content: "";
  display: inline-block;
  min-width: 10px;
  height: 10px;
  border-radius: 7.5px;
  background-color: #339244;
  margin-top: 6px;
}

.schedule-days-container {
  padding: 1rem 0.5rem;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-gap: 0.5rem;
  overflow: scroll;
  max-width: 100%;
}
.schedule-days-container .day {
  /* background-color: #eee; */
  border-color: transparent;
  color: #272b41;
  border-radius: 4px;
  padding: 6px 15px;
  text-transform: uppercase;
  border: 1px solid #dcddea;
  text-align: center;
  cursor: pointer;
}
.schedule-days-container .day.active {
  background: #45bd5b;
  border: 1px solid #45bd5b !important;
  color: #fff;
}
.schedule-days-container .day:hover {
  background-color: #eee;
  border-color: transparent;
  color: #272b41;
  border-bottom-color: #ddd;
}
.heading-container {
  display: flex;
  justify-content: space-between;
  padding: 0rem 0.5rem;
}
.time-slot-manage-heading {
  color: #0fa0cf;
  font-size: 16px;
  margin-top: 4px;
  cursor: pointer;
  margin: 0px;
}
.time-slot-heading {
  font-size: 1.125rem;
  color: #272b41;
  font-weight: 500;
}
.slots-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, 90px);
  grid-gap: 0.3rem;
}
.slots-container .slot {
  background-color: #0fa0cf;
  border: none;
  background-image: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0.3),
    rgba(255, 255, 255, 0)
  );
  padding: 5px 10px;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
}
.manage-slots-card {
  border-radius: 7px;
  background: #fff;
  padding: 1rem;
  min-height: 60vh;
}
.heading-container .manage-slot-heading {
  font-size: 1.125rem;
  color: #272b41;
  font-weight: 500;
  margin: 0px;
}
.btn-delete {
  background: #ff5d5d;
  border-radius: 7px;
  padding: 8px 10px;
  cursor: pointer;
}
.manage-container .icon {
  font-size: 0.9rem;
  color: #ffffff;
  cursor: pointer;
}
.buttons-container-times-marking {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  gap: 0.5rem;
  overflow: scroll;
  max-width: 100%;
}
.buttons-container-times-marking button.tab {
  background: #0fa0cf;
  color: #fff;
  border: #0fa0cf;
}
.working-hours-container {
  display: grid;
  margin: 1rem 0rem;
  grid-gap: 1rem;
  gap: 1rem;
  place-items: center;
}
.working-hours-item {
  padding: 0.6rem;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e5e5;
  color: #222;
  font-size: 13px;
  width: 90%;
}
.details-container {
  width: 100%;
  padding: 0.6rem;
  border-radius: 7px;
  border: 1px solid #e5e5e5;
  color: #222;
  background: #f5f8f9;
}
.details-container p {
  margin: 0;
}
.settings-container {
  padding: 1rem;
}
.buttons-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1rem;
  gap: 1rem;
}
@media screen and (max-width: 768px) {
  .buttons-container {
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 576px) {
  .buttons-container {
    grid-template-columns: 1fr;
  }
}
.hospital-description {
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  color: #4d4d4de7;
  font-size: 14px;
}
.hospital-description .icon {
  font-size: 16px;
  color: #0fa0cf;
  cursor: pointer;
}
.leaves-container {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
/* width */
::-webkit-scrollbar {
  height: 7px;
  width: 9px;
}

Track ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(185, 185, 185);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(185, 185, 185);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b1b1b1;
}
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0px;
}

.leaflet-container{
  height:600px;
  width:100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/index.css"],"names":[],"mappings":"AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,YAAY;EACZ,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,YAAY;EACZ,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;;;;;;;;;EAUE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,iCAAiC;AACnC;AACA;;EAEE,0BAA0B;AAC5B;AACA;;;;;;;;;EASE,kBAAkB;AACpB;;AAEA,eAAe;AACf;;EAEE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;;EAEE,gBAAgB;AAClB;AACA;;;;;EAKE,kCAAkC;EAClC,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oDAAoD;AACtD;AACA;;;;;EAKE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;EAKE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;AACA;;;EAGE,oDAAoD;AACtD;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,aAAa;AACf;AACA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;;;;;;EAOE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,aAAa;AACf;AACA;;EAEE,sBAAsB;EACtB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;;;;;;EASE,mBAAmB;AACrB;AACA;;;;EAIE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;;;;;;;EAQE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;;;EAGE,YAAY;AACd;AACA;;;;EAIE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;AACA;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;;EAGE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;AACA;;GAEG;AACH;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;;;;;;;;;EAUE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,YAAY;EAGZ,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ;;;;GAIC;EACD,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,cAAS;EAAT,SAAS;AACX;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA,UAAU;AACV;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ","sourcesContent":["@import \"./globalVariables.css\";\n.w-full {\n  width: 100%;\n}\n.header-right-content {\n  display: inline-block;\n  float: right;\n  margin-right: 15px;\n}\n.p-0 {\n  padding: 0px !important;\n}\n.shadow-picker.ant-picker {\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n  border: none;\n  height: 40px;\n}\n.shadow-input {\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n  border: none;\n  height: 40px;\n}\n.shadow-select .ant-select-selector {\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n  border: none !important;\n  height: 40px !important;\n}\n.shadow-select .ant-select-selection-placeholder {\n  line-height: 40px !important;\n}\n.shadow-select .ant-select-selector .ant-select-selection-item {\n  line-height: 40px;\n}\n.p-6 {\n  padding: 1.4rem;\n}\n.max-width-100 {\n  max-width: 100%;\n}\n.full-width {\n  width: 100%;\n}\n.is-active {\n  background: var(--sd_primary);\n}\n.table-search-bar .form-control {\n  color: #222;\n  background-color: #f0f2f5;\n  border: 1px solid #f0f2f5;\n}\n.table td,\n.table th {\n  border-top: 1px solid #f0f2f5;\n  vertical-align: middle;\n}\n.table td p {\n  margin-bottom: 0px !important;\n}\n.ant-dropdown-button button {\n  background: #f0f2f5;\n  border: none;\n}\n.ant-dropdown-button button:hover,\n.ant-dropdown-button button:focus,\n.ant-dropdown-button button:active {\n  background: #f0f2f5;\n  border: none;\n  color: #45bd5b;\n}\n.total-spinner {\n  position: fixed;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.total-spinner-backdrop {\n  z-index: 99;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #ffffff99;\n}\n.ant-spin-dot-item {\n  background: #45bd5b;\n}\n.react-bootstrap-table .anticon-eye svg {\n  color: var(--sd_primary);\n  font-size: 16px;\n  cursor: pointer;\n}\n.dashboard-layout .logo img {\n  height: 32px;\n  margin: 16px;\n}\n.ant-layout-sider-collapsed .logo img {\n  margin: 15px 24px;\n}\n.ant-menu-inline-collapsed > .ant-menu-item,\n.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n  padding: 0px 24px;\n  text-align: center;\n}\n.ant-menu-inline-collapsed .sidebar-icon {\n  margin-right: 0px;\n}\n.ant-layout-sider {\n  flex: 0 0 230px !important;\n  max-width: 230px !important;\n  min-width: 230px !important;\n  width: 230px !important;\n}\n.ant-layout-sider-collapsed {\n  flex: 0 0 80px !important;\n  max-width: 80px !important;\n  min-width: 80px !important;\n  width: 80px !important;\n}\n\n.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type),\n.ant-tabs-card.ant-tabs-bottom > .ant-tabs-nav .ant-tabs-tab:not(:last-of-type),\n.ant-tabs-card.ant-tabs-top\n  > div\n  > .ant-tabs-nav\n  .ant-tabs-tab:not(:last-of-type),\n.ant-tabs-card.ant-tabs-bottom\n  > div\n  > .ant-tabs-nav\n  .ant-tabs-tab:not(:last-of-type) {\n  margin-right: 8px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.add-content-button {\n  z-index: 9;\n  margin-bottom: 10px;\n  float: right;\n}\n.view-name {\n  cursor: pointer;\n}\n.view-name:hover {\n  color: #45bd5b;\n}\n.ant-pagination-item-active {\n  border-color: var(--sd_primary);\n}\n.ant-pagination-item-active a {\n  color: var(--sd_primary);\n}\n.ant-pagination-item-active:focus,\n.ant-pagination-item-active:hover {\n  border-color: var(--sd_secondary);\n}\n.ant-pagination-item-active:focus a,\n.ant-pagination-item-active:hover a {\n  color: var(--sd_secondary);\n}\n.ant-input,\n.ant-select:not(.ant-select-customize-input) .ant-select-selector,\n.ant-select:not(.ant-select-customize-input) .ant-select-selector,\n.ant-picker,\n.ant-btn,\n.ant-card,\n.ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab,\n.ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab,\n.ant-alert {\n  border-radius: 7px;\n}\n\n/* tab styles */\n.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active,\n.ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active {\n  background: #0fa0cf;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff;\n}\n.ant-tabs-tab:hover {\n  color: #0fa0cf;\n}\n\n/* practitioner details card tab styles */\n.tab-style > .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {\n  background: var(--sd_secondary);\n}\n.item-details-modal .ant-tabs-tab:hover {\n  color: var(--sd_secondary);\n}\n.ant-list-split .ant-list-item {\n  border: none;\n}\n.data-table {\n  position: relative;\n}\n.data-table thead {\n  background: var(--sd_primary_low);\n  color: var(--sd_primary_dark);\n}\n.data-table .table thead th {\n  outline-color: var(--sd_primary);\n}\n.react-bootstrap-table-pagination .page-item.active .page-link {\n  background: var(--sd_primary_dark);\n  border-color: var(--sd_primary_dark);\n  outline: none;\n}\n.react-bootstrap-table-pagination .page-link:focus {\n  outline: none;\n  box-shadow: none;\n}\n.react-bootstrap-table-pagination .page-link {\n  color: var(--sd_primary);\n}\n.react-bootstrap-table-pagination .active .page-link:hover {\n  color: var(--white);\n}\n.react-bootstrap-table-pagination .page-link:hover {\n  color: var(--sd_primary_dark);\n}\n.react-bootstrap-table-pagination .btn-secondary {\n  background-color: var(--sd_primary);\n  border-color: var(--sd_primary);\n}\n.react-bootstrap-table-pagination .btn-secondary.focus,\n.btn-secondary:focus {\n  box-shadow: none;\n}\n.react-bootstrap-table-pagination\n  .btn-secondary:not(:disabled):not(.disabled).active,\n.react-bootstrap-table-pagination\n  .btn-secondary:not(:disabled):not(.disabled):active,\n.react-bootstrap-table-pagination .show > .btn-secondary.dropdown-toggle {\n  background: var(--sd_primary_dark);\n  border-color: var(--sd_primary_dark);\n  outline: none;\n  box-shadow: none;\n}\n.react-bootstrap-table-pagination .dropdown-menu a {\n  color: var(--sd_primary);\n}\n.ant-btn:hover,\n.ant-btn:focus {\n  color: var(--sd_primary);\n  border-color: var(--sd_primary);\n}\n.data-table .table thead th {\n  border-bottom: none;\n}\n.data-table .table th {\n  border-top: none;\n}\n.search-label {\n  float: right;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.react-bootstrap-table-pagination-total {\n  margin-left: 15px;\n}\n.sidebar-icon {\n  width: 1.2rem;\n  margin-right: 10px;\n}\n.ant-menu-inline-collapsed {\n  width: 100%;\n}\n.ant-menu-inline-collapsed .ant-menu-submenu-title span {\n  display: inline-block;\n  max-width: 0;\n  opacity: 0;\n}\n.ant-table-column-sorter-up.active,\n.ant-table-column-sorter-down.active {\n  color: var(--sd_primary_dark);\n}\n.ant-table-thead th.ant-table-column-has-sorters:hover {\n  background: var(--sd_primary_low);\n}\n.ant-btn-primary {\n  background: #45bd5b;\n  border: none;\n}\n.ant-btn-secondary {\n  background: #0fa0cf;\n  border: none;\n  color: var(--white);\n}\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background: linear-gradient(60deg, #66bb6a, #43a047);\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus,\n.ant-btn-primary:active,\n.ant-btn-primary:focus-within,\n.ant-btn-primary:visited {\n  background: #24ad3e;\n  border: none;\n  color: var(--white);\n}\n.ant-btn-secondary:hover,\n.ant-btn-secondary:focus,\n.ant-btn-secondary:active,\n.ant-btn-secondary:focus-within,\n.ant-btn-secondary:visited {\n  background: #0e93c0;\n  border: none;\n  color: var(--white);\n}\n.dashboard-layout .trigger {\n  padding: 0 24px;\n  font-size: 18px;\n  line-height: 64px;\n  cursor: pointer;\n  transition: color 0.3s;\n  color: var(--sd_primary);\n}\n\n.dashboard-layout .trigger:hover {\n  color: var(--sd_secondary);\n}\n.dashboard-layout\n  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)\n  .ant-menu-item-selected {\n  background: linear-gradient(60deg, #66bb6a, #43a047);\n}\n.alpha-dummy-avatar {\n  text-transform: uppercase;\n  text-align: center;\n  height: 70px;\n  width: 70px;\n  line-height: 70px;\n  font-size: 34px;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 5px;\n  color: var(--white);\n  background: var(--sd_primary);\n}\n.ant-menu-sub .ant-menu-item {\n  padding-left: 30px !important;\n}\n\n.dashboard-layout .site-layout .site-layout-background {\n  background: var(--white);\n}\n.dashboard-layout .ant-layout-content {\n  min-height: 84vh !important;\n}\n.dashboard-layout .site-layout-background.content {\n  margin: 24px 16px;\n  padding: 12px 24px;\n  min-height: 280px;\n}\n.table-avatar {\n  border-radius: 5px;\n  border: 1px solid;\n  border-color: var(--light_grey);\n  height: 40px;\n  width: 40px;\n  overflow: hidden;\n  margin-right: 10px;\n  display: inline-block;\n}\nul.languages-spoken-names {\n  list-style: none;\n  display: inline-flex;\n  margin-bottom: 0px;\n  padding-left: 0px;\n}\nul.languages-spoken-names li:not(:last-child):after {\n  content: \", \";\n}\n\n.doctor-speciality {\n  padding: 3px 12px;\n  color: #45bd5b;\n  text-transform: uppercase;\n  background: #ffffff;\n  border-radius: 3px;\n  font-weight: 600;\n  box-shadow: 1px 2px 7px #00000045;\n  font-size: 12px;\n}\n.table-avatar img {\n  max-width: 100%;\n  height: auto;\n}\n.table-avatar-name span {\n  display: inline-block;\n}\n.ant-switch {\n  background-color: var(--light_red);\n}\n.item-details-modal .ant-modal-header {\n  display: none;\n}\n.item-details-modal .ant-modal-content {\n  border-radius: 10px;\n}\n.item-details-modal .ant-tabs-nav {\n  margin-bottom: 5px;\n}\n.item-details-modal .ant-tabs-content-holder {\n  padding: 0px;\n}\n.item-details-modal .ant-tabs-content-holder .general-info .column-items {\n  margin: 0px 0px 5px 0px;\n}\n.item-details-modal .ant-tabs-content-holder .general-info .column-item {\n  margin: 0px;\n  padding: 5px;\n}\n.general-info .column-item-inner {\n  background: #f5f8f9;\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n}\n.item-details-modal .contact-info {\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  display: flex;\n}\n.item-details-modal .contact-info svg {\n  color: #45bd5b;\n}\n.item-details-modal .health-info-row {\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  display: flex;\n}\n.item-details-modal .blood-group,\n.item-details-modal .weight,\n.item-details-modal .height {\n  flex-grow: 1;\n  margin-bottom: 10px;\n  padding: 0px 5px;\n}\n.item-details-modal .contact-info .email,\n.item-details-modal .contact-info .mobile,\n.item-details-modal .contact-info .address,\n.item-details-modal .contact-info .telephone,\n.item-details-modal .contact-info .user,\n.item-details-modal .contact-info .auto-approval,\n.item-details-modal .contact-info .languages-spoken {\n  flex-grow: 1;\n  margin-bottom: 10px;\n  padding: 0px 5px;\n  width: 50%;\n}\n\n.item-details-modal .contact-info svg {\n  margin-right: 5px;\n}\n.item-details-modal .department-info,\n.item-details-modal .service-info {\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  display: flex;\n}\n.item-details-modal .department-info span,\n.item-details-modal .service-info span {\n  vertical-align: middle;\n  flex-grow: 1;\n}\n.item-details-modal .department-info span.item,\n.item-details-modal .service-info span.item {\n  font-size: 14px;\n  flex-grow: inherit;\n  border: 1px solid #45bd5b38;\n  border-radius: 5px;\n  margin: 3px;\n  padding: 2px 10px;\n  background: #45bd5b0d;\n}\n.item-details-modal .department-info span.item svg,\n.item-details-modal .service-info span.item svg {\n  color: #45bd5b;\n  margin-right: 5px;\n}\n.item-details-modal .cover-image-holder {\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  height: 100px;\n  background-position: 50% 45%;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.item-details-modal .profile-image {\n  border-radius: 10px;\n  height: 90px;\n  display: inline-block;\n  box-shadow: 0 0 15px #00000014;\n  width: 90px;\n  border: 3px solid #fff;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  margin-top: -45px;\n}\n.data-table > .react-bootstrap-table {\n  margin-top: 0px;\n}\n.item-details-modal .profile-info {\n  vertical-align: text-bottom;\n  display: inline-block;\n  padding: 0px 10px;\n}\n.profile-info h4 {\n  margin-bottom: 0px;\n}\n.profile-info svg {\n  color: #45bd5b;\n  margin-right: 3px;\n}\n.item-details-modal .basic-information {\n  margin-top: -35px;\n  padding: 20px;\n}\n.item-details-modal .basic-information.doctor {\n  margin-top: -35px;\n}\n.item-details-modal .ant-modal-body {\n  padding: 0px;\n}\n.item-details-modal .ant-modal-close-x {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.working-hours .day {\n  display: flex;\n  padding: 5px;\n}\n.working-hours .day .label {\n  min-width: 100px;\n  font-weight: 600;\n}\n.ant-switch-checked {\n  background: #45bd5b;\n}\n.order-item {\n  cursor: pointer;\n}\n.react-bootstrap-table {\n  max-width: 100%;\n  overflow: scroll;\n  margin-top: 25px;\n}\n.ant-steps-vertical.ant-steps-dot .ant-steps-item-icon {\n  margin-top: 13px;\n  margin-right: 7px;\n}\n.ant-steps-item-process\n  .ant-steps-item-icon\n  > .ant-steps-icon\n  .ant-steps-icon-dot,\n.ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,\n.ant-steps-item-process\n  > .ant-steps-item-container\n  > .ant-steps-item-tail::after,\n.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background: #45bd5b;\n}\n.ant-steps-item-process\n  > .ant-steps-item-container\n  > .ant-steps-item-content\n  > .ant-steps-item-title {\n  font-size: 14px !important;\n  line-height: 30px !important;\n}\n.ant-steps-item-wait\n  > .ant-steps-item-container\n  > .ant-steps-item-content\n  > .ant-steps-item-title,\n.ant-steps-item-wait\n  > .ant-steps-item-container\n  > .ant-steps-item-content\n  > .ant-steps-item-description {\n  color: #222 !important;\n}\n.ant-steps-item-description {\n  font-size: 12px;\n  color: #222 !important;\n}\n.data-table h5 {\n  display: inline;\n  margin-bottom: 0px;\n}\n.table-search-bar {\n  position: relative;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media only screen and (max-width: 600px) {\n  .table-search-bar {\n    justify-content: center;\n  }\n}\n\n.table-search-bar input {\n  width: 300px;\n}\n.go-back-icon {\n  margin-right: 10px;\n}\n.go-back-icon svg {\n  height: 20px;\n  width: 20px;\n  vertical-align: text-bottom;\n  color: #45bd5b;\n}\n.ant-drawer-header,\n.ant-modal-header {\n  padding: 10px 24px;\n  background: #45bd5b1a;\n}\n.ant-drawer-close {\n  padding: 12px;\n}\n.ant-drawer-title,\n.ant-modal-title {\n  color: #45bd5b;\n}\n.ant-modal-close-x {\n  width: 42px;\n  height: 42px;\n  line-height: 42px;\n}\n.ant-modal-footer button:first-child {\n  border: none;\n  background: #f0f2f5;\n}\n.ant-drawer-body input[type=\"text\"] {\n  height: 40px;\n  line-height: 40px;\n}\n.ant-drawer-body\n  .ant-select-show-search.ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  height: 40px;\n}\n.ant-drawer-body\n  .ant-select-single\n  .ant-select-selector\n  .ant-select-selection-item {\n  line-height: 40px;\n}\n.fileUploader {\n  width: 50%;\n}\n.fileContainer {\n  box-shadow: none !important;\n  padding: 0px;\n}\n.fileContainer .chooseFileButton {\n  background: #eff2f5 !important;\n  color: #222 !important;\n}\n.procedure-image-uploader {\n  display: flex;\n  padding: 15px 0px;\n}\n.procedure-preview-image {\n  height: 120px;\n  padding: 15px;\n  width: auto;\n}\n.ql-toolbar.ql-snow,\n.ql-container.ql-snow {\n  border: 1px solid #eff2f5;\n}\n.procedure-gallery-uploader {\n}\n.procedure-gallery-uploader p {\n  padding: 20px 10px;\n  text-align: center;\n  border-radius: 5px;\n  background: #eff2f5;\n  border: 1px dotted #ddd;\n  margin-bottom: 0px;\n}\n.app_status {\n  font-size: 12px;\n  border-radius: 3px;\n  border: 1px solid;\n  padding: 3px 9px;\n}\n.app_status.notresponded {\n  border-color: #e29200;\n  background: #ffa50036;\n  color: #e29200;\n}\n.app_status.notattended {\n  border-color: #929292;\n  background: #9292922b;\n  color: #929292;\n}\n.app_status.completed {\n  border-color: #0fa0cf;\n  background: #0fa0cf1f;\n  color: #0fa0cf;\n}\n.app_status.checkedin {\n  border-color: #096dd9;\n  background: #096dd926;\n  color: #096dd9;\n}\n.app_status.pending {\n  border-color: #ff6c04;\n  background: #ff6c0426;\n  color: #ff6c04;\n}\n.app_status.cancelled {\n  border-color: #dc3545;\n  background: #dc354529;\n  color: #dc3545;\n}\n.app_status.approved {\n  border-color: #28a745;\n  background: #28a7452e;\n  color: #28a745;\n}\n.app_status.rescheduled {\n  border-color: #28a7a1;\n  background: #28a7a121;\n  color: #28a7a1;\n}\n.app_status.checkedout {\n  border-color: #0e7526;\n  background: #0e75262e;\n  color: #0e7526;\n}\n.app_status.videoconference {\n  border-color: #9703a9;\n  background: #9703a92b;\n  color: #9703a9;\n}\n.anticon {\n  vertical-align: middle;\n}\nbutton.add-procedure {\n  margin-top: 15px;\n  width: 100%;\n  padding: 10px;\n  height: 40px;\n  color: #fff;\n  line-height: 10px;\n  background: #45bd5b;\n}\nbutton.add-procedure:hover {\n  color: #fff;\n  background: #45bd5b;\n}\n.appointments-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.row-align-right {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 1rem;\n}\n.patient-details-container,\n.procedure-container,\n.quickbooking-container {\n  background-color: white;\n  padding: 18px;\n  border-radius: 6px;\n}\n.appointments-history-container {\n  background-color: white;\n  padding: 18px;\n  border-radius: 6px;\n  margin-top: 1rem;\n}\n.appointment-details-container {\n  background-color: white;\n  padding: 15px;\n}\n.item-details-modal .general-info {\n  display: flex;\n  flex-direction: column;\n}\n.item-details-modal .general-info .item {\n  display: flex;\n  flex-direction: column;\n  margin: 0px;\n  padding: 5px;\n}\n.item h4 {\n  margin: 0;\n}\n.item .label-gray {\n  color: gray;\n  font-size: 15px;\n  margin-bottom: 0px;\n}\n.item .text-black {\n  color: black;\n  font-size: 18px;\n  margin-top: 0px;\n}\n.appointment-id {\n  padding: 3px 12px;\n  color: #45bd5b;\n  text-transform: uppercase;\n  background: #ffffff;\n  border-radius: 3px;\n  font-weight: 600;\n  box-shadow: 1px 2px 3px #00000045;\n  font-size: 16px;\n  margin-top: 3px;\n}\n.appointment-token{\n  padding: 3px 10px;\n  color: #45bd5b;\n  text-transform: uppercase;\n  background: #ffffff;\n  border-radius: 3px;\n  font-weight: 400;\n  font-size: 12px;\n  margin: 3px;\n  border: 1px solid rgba(220, 220, 220, 0.7);\n}\n.dob-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n.dob-wrapper .label {\n  font-size: 13px;\n  color: gray;\n}\n.dob-wrapper .dob {\n  font-size: 14px;\n  color: black;\n  margin-left: 5px;\n  font-weight: 500;\n}\n.details-wraper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  margin-top: 5px;\n  padding: 3px 15px;\n  border-radius: 5px;\n  width: 100%;\n  background: #f5f8f9;\n}\n.details-wraper h4,\nlabel {\n  margin: 0;\n}\n.details-wraper .icon {\n  height: 18px;\n  width: auto;\n}\n.details-wraper label {\n  font-size: 16px;\n  color: gray;\n  min-width: 32%;\n  font-weight: normal;\n}\n.details-wraper .text {\n  font-size: 16px;\n  color: rgb(19, 19, 19);\n  margin-left: 8px;\n  font-weight: 400;\n}\n.prescription-container,\n.report-container {\n  padding: 1rem;\n}\n.prescription-container h1 {\n  font-size: 15px;\n  color: rgb(63, 63, 63);\n}\n.order-details-container .general-info {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-top: 0px;\n}\n.payments-container,\n.appointments-container {\n  /* background-color: white; */\n  border-radius: 7px;\n}\n.reschedule-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.reschedule-container .header-section {\n  width: 100%;\n  height: 3rem;\n  background-color: white;\n  display: flex;\n  flex-direction: row;\n  padding: 1rem;\n  position: relative;\n}\n.reschedule-container .date-header {\n  font-size: 14px;\n  font-weight: 500;\n  color: black;\n  margin-right: 3px;\n}\n.reschedule-container .today-header {\n  font-size: 14px;\n  font-weight: 500;\n  color: #7dbe7a;\n  margin-left: 6px;\n  cursor: pointer;\n}\n.reschedule-container .disabled {\n  color: rgb(139, 139, 139);\n  font-weight: 400;\n}\n.reschedule-container .right-section {\n  align-self: center;\n  position: absolute;\n  right: 2rem;\n}\n.reschedule-container .dates-container {\n  width: 100%;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #fcfcfc;\n  overflow: scroll hidden;\n  margin-bottom: 10px;\n}\n.dates-container .date-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid gray;\n  border-radius: 3px;\n  padding: 10px 5px;\n  cursor: pointer;\n  color: gray;\n  margin-left: 10px;\n  height: 60px;\n}\n.dates-container .selected {\n  background-color: #7dbe7a;\n  border: none;\n}\n.date-card .day {\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0;\n  margin-bottom: 0.5rem;\n}\n.date-card .selected {\n  color: white;\n  font-weight: 600;\n}\n.date-card .month {\n  font-size: 8px;\n  font-weight: 400;\n  margin: 0;\n  text-align: center;\n  width: 40px;\n}\n.reschedule-container .times-container {\n  width: 100%;\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 0.5rem;\n}\n.times-container .time-card {\n  display: grid;\n  place-items: center;\n  border-radius: 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.25rem;\n  user-select: none;\n  cursor: pointer;\n  background-color: rgba(239, 243, 247);\n  font-weight: 600;\n  color: rgba(75, 89, 102);\n  pointer-events: auto;\n}\n\n.times-container .disabled {\n  background-color: rgb(245, 245, 245);\n  font-weight: 500;\n  color: rgb(146, 146, 146);\n}\n.times-container .selected {\n  color: rgba(116, 190, 118);\n  border: 1px solid rgba(116, 190, 118);\n  font-weight: 700;\n  background-color: white;\n}\n.times-container .leave {\n  color: #ff0000;\n  border: 1px solid rgb(252, 65, 65);\n  font-weight: 700;\n  background-color: white;\n}\n.reschedule-container .btn-footer {\n  width: 100%;\n  padding: 0.5rem 0.5rem;\n  display: grid;\n  place-items: center;\n  font-size: 18px;\n  font-weight: 500;\n  color: white;\n  background-color: #7dbe7a;\n  border-radius: 0px 0px 5px 5px;\n  cursor: pointer;\n}\n.reschedule-container .btn-footer:hover{\n  font-style: italic;\n  box-shadow: 2px -2px 5px 1px #575457;\n}\n/* .image-cropper-modal .ant-modal-footer{\n  display: none;\n} */\n.reschedule-container .btn-footer:active { \n  transform: scale(0.8);  \n} \n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: white;\n}\n@media (max-width: 992px) {\n  .dashboard-layout .site-layout-background.content {\n    overflow: scroll;\n  }\n}\n@media (max-width: 767px) {\n  .add-content-button {\n    float: left;\n  }\n  .react-bootstrap-table-pagination .btn-secondary {\n    margin-bottom: 10px;\n  }\n}\n.action_status.requested {\n  border-color: #e29200;\n  background: #ffa50036;\n  color: #e29200;\n}\n.action_status.accept {\n  border-color: #28a745;\n  background: #28a7452e;\n  color: #28a745;\n}\n.action_status.reject {\n  border-color: #dc3545;\n  background: #dc354529;\n  color: #dc3545;\n}\n.action_status.send_request {\n  border-color: #096dd9;\n  background: #096dd926;\n  color: #096dd9;\n}\n\n.ant-input-affix-wrapper {\n  border-radius: 7px;\n}\n\n.table > thead > tr > th:first-child {\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n}\n.table > thead > tr > th:last-child {\n  border-top-right-radius: 7px;\n  border-bottom-right-radius: 7px;\n}\n.ant-input-group.ant-input-group-compact > *:first-child,\n.ant-input-group.ant-input-group-compact\n  > .ant-select:first-child\n  > .ant-select-selector,\n.ant-input-group.ant-input-group-compact\n  > .ant-select-auto-complete:first-child\n  .ant-input,\n.ant-input-group.ant-input-group-compact\n  > .ant-cascader-picker:first-child\n  .ant-input {\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n  /* border-radius: 10px; */\n}\n@media (min-width: 991px) {\n  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {\n    position: absolute;\n  }\n}\n\n/* notification css*/\n\n.notification_container {\n  padding: 10px;\n  height: 100%;\n  background: #fafafc;\n}\n\n.notification_container > .title_day {\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #8e95a5;\n}\n\n.title_container {\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n}\n\n.notification {\n  cursor: pointer;\n  margin-top: 8px;\n  padding: 6px;\n  background: #fff;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  border-radius: 7px;\n}\n.notification_bottom {\n  cursor: pointer;\n  text-align: center;\n  margin-top: 15px;\n  background: #45bd5b;\n  color: white;\n  font-weight: 600;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.divider {\n  padding-top: 6px;\n  border-bottom: 2px solid #f8f8f8;\n  margin-left: 2%;\n}\n\n.notification > .title_container > .title {\n  font-weight: normal;\n  font-size: 14px;\n  width: 300px;\n  line-height: 1.3;\n}\n\n.notification > .title_container > .time {\n  font-weight: 600;\n  color: #acacac;\n  font-size: 12px;\n}\n\n.notification > .circle {\n  content: \"\";\n  display: inline-block;\n  min-width: 10px;\n  height: 10px;\n  -moz-border-radius: 7.5px;\n  -webkit-border-radius: 7.5px;\n  border-radius: 7.5px;\n  background-color: #339244;\n  margin-top: 6px;\n}\n\n.schedule-days-container {\n  padding: 1rem 0.5rem;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-gap: 0.5rem;\n  overflow: scroll;\n  max-width: 100%;\n}\n.schedule-days-container .day {\n  /* background-color: #eee; */\n  border-color: transparent;\n  color: #272b41;\n  border-radius: 4px;\n  padding: 6px 15px;\n  text-transform: uppercase;\n  border: 1px solid #dcddea;\n  text-align: center;\n  cursor: pointer;\n}\n.schedule-days-container .day.active {\n  background: #45bd5b;\n  border: 1px solid #45bd5b !important;\n  color: #fff;\n}\n.schedule-days-container .day:hover {\n  background-color: #eee;\n  border-color: transparent;\n  color: #272b41;\n  border-bottom-color: #ddd;\n}\n.heading-container {\n  display: flex;\n  justify-content: space-between;\n  padding: 0rem 0.5rem;\n}\n.time-slot-manage-heading {\n  color: #0fa0cf;\n  font-size: 16px;\n  margin-top: 4px;\n  cursor: pointer;\n  margin: 0px;\n}\n.time-slot-heading {\n  font-size: 1.125rem;\n  color: #272b41;\n  font-weight: 500;\n}\n.slots-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 90px);\n  grid-gap: 0.3rem;\n}\n.slots-container .slot {\n  background-color: #0fa0cf;\n  border: none;\n  background-image: -webkit-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.3),\n    rgba(255, 255, 255, 0)\n  );\n  padding: 5px 10px;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.manage-slots-card {\n  border-radius: 7px;\n  background: #fff;\n  padding: 1rem;\n  min-height: 60vh;\n}\n.heading-container .manage-slot-heading {\n  font-size: 1.125rem;\n  color: #272b41;\n  font-weight: 500;\n  margin: 0px;\n}\n.btn-delete {\n  background: #ff5d5d;\n  border-radius: 7px;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n.manage-container .icon {\n  font-size: 0.9rem;\n  color: #ffffff;\n  cursor: pointer;\n}\n.buttons-container-times-marking {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  gap: 0.5rem;\n  overflow: scroll;\n  max-width: 100%;\n}\n.buttons-container-times-marking button.tab {\n  background: #0fa0cf;\n  color: #fff;\n  border: #0fa0cf;\n}\n.working-hours-container {\n  display: grid;\n  margin: 1rem 0rem;\n  gap: 1rem;\n  place-items: center;\n}\n.working-hours-item {\n  padding: 0.6rem;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e5e5e5;\n  color: #222;\n  font-size: 13px;\n  width: 90%;\n}\n.details-container {\n  width: 100%;\n  padding: 0.6rem;\n  border-radius: 7px;\n  border: 1px solid #e5e5e5;\n  color: #222;\n  background: #f5f8f9;\n}\n.details-container p {\n  margin: 0;\n}\n.settings-container {\n  padding: 1rem;\n}\n.buttons-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1rem;\n}\n@media screen and (max-width: 768px) {\n  .buttons-container {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media screen and (max-width: 576px) {\n  .buttons-container {\n    grid-template-columns: 1fr;\n  }\n}\n.hospital-description {\n  display: grid;\n  grid-template-columns: 16px 1fr;\n  gap: 0.5rem;\n  color: #4d4d4de7;\n  font-size: 14px;\n}\n.hospital-description .icon {\n  font-size: 16px;\n  color: #0fa0cf;\n  cursor: pointer;\n}\n.leaves-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n/* width */\n::-webkit-scrollbar {\n  height: 7px;\n  width: 9px;\n}\n\nTrack ::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px rgb(185, 185, 185);\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgb(185, 185, 185);\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #b1b1b1;\n}\n.ant-collapse-content > .ant-collapse-content-box {\n  padding: 0px;\n}\n\n.leaflet-container{\n  height:600px;\n  width:100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
